import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=bd91cd7a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=bd91cd7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd91cd7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd91cd7a')) {
      api.createRecord('bd91cd7a', component.options)
    } else {
      api.reload('bd91cd7a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=bd91cd7a&scoped=true&", function () {
      api.rerender('bd91cd7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ShnA83etwx5q/JS/comp/PopupBox.vue"
export default component.exports